export default __webpack_public_path__ + "static/media/errorImage.0b19f0b7.png";